import DOMPurify from 'dompurify'
import { marked } from 'marked'
import { cn } from '../../lib/utils'

// Force rel=noopener noreferrer on _blank links to prevent tabnabbing.
// Guarded: in Node.js test environments DOMPurify is the uninitialised factory (no window),
// so addHook doesn't exist — skip registration there; sanitize is also a no-op in that context.
if (typeof DOMPurify.addHook === 'function') {
	DOMPurify.addHook('afterSanitizeAttributes', (node) => {
		if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
			node.setAttribute('rel', 'noopener noreferrer')
		}
	})
}

export const MarkdownPreview = ({ markdown, className }: { markdown: string; className?: string }) => {
	const raw =
		typeof markdown === 'string' && markdown.trim() ? (marked.parse(markdown, { async: false }) as string) : ''
	const html = DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } })

	return (
		// biome-ignore lint/security/noDangerouslySetInnerHtml: html is sanitized by DOMPurify before render
		<div className={cn('tiptap text-left', className)} dangerouslySetInnerHTML={{ __html: html }} />
	)
}
